module.exports = __webpack_public_path__ + "static/img/app-3.7af440a7.jpg";